import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { Footer, Header, Meta } from '$partials/global';
import { useLocale } from '$contexts/locale.jsx';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const ErrorPage = ({
    data,
    domain,
    err
}) => {
    const { translate: T } = useLocale();

    const [isOpen, setIsOpen] = useState(false);

    const status = err?.status || 500;
    let message = '';

    switch (status) {
    case 404:
        message = 'Page not found.';
        break;

    default:
        message = 'Sorry, something went wrong.';
    }

    return (
        <>
            <Meta />

            <Header
                isOpen={isOpen}
                menu={data?.navigation}
                setIsOpen={setIsOpen}/>

            <main
                className='layout-container'
                id='main-content'>

                <article className='flex flex-col md:flex-row md:justify-between pt-60 sm:pt-75 md:pt-100'>

                    {/* Header */}
                    <header className='w-full md:w-5/12 px-10 sm:px-20 mb-40 md:mb-100'>
                        <h1 className='type-style-2 inline mr-10'>{T(`Error ${status}`)}</h1>

                        {message &&
                            <div className='mt-10 md:mt-20'>
                                {T(message)}
                            </div>
                        }

                    </header>
                </article>

                {data?.footer &&
                    <Footer
                        domain={domain}
                        menu={data.footer}/>
                }
            </main>
        </>
    );
};

/* =========================================================================  */
/* Typing and exports */
/* =========================================================================  */

const propTypes = {
    data: PropTypes.object,
    domain: PropTypes.string,
    err: PropTypes.object,
    navigation: PropTypes.object,
};

ErrorPage.propTypes = propTypes;

export default ErrorPage;
